import styled from 'styled-components';
import StatusModal from 'components/StatusModal';
import {device} from 'styled/device';
import {Button} from '@guestapp/ui';

export const StyledStatusModal = styled(StatusModal)`
  &-content {
    padding: 48px 24px;
    height: 100vh;
    & .modal__title {
      margin: 24px auto 0;
    }

    & .modal__description {
      margin: 24px auto 0;
    }
  }

  @media (min-width: ${device.mobileXL}) {
    &-content {
      max-width: 375px;
      height: auto;
    }
  }
`;

export const OkButton = styled(Button)`
  max-width: 294px;
  margin-top: 48px;
`;
